import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Button, Tooltip } from "@mui/material";
import { useScribeCollapse } from "../../../../contexts/ScribeCollapseContext";
import useEntitlements from "../../../../hooks/useEntitlements";

export default function ScribeFormToggle() {
  const { isScribeAvailable, isScribeCollapsed, toggleScribe } =
    useScribeCollapse();
  const { can } = useEntitlements();
  const hasScribe = can("ai_scribe");

  if (!isScribeAvailable && hasScribe) return null;

  if (!hasScribe) {
    return (
      <Tooltip title="Upgrade to Essentials to get access to the feature">
        <span>
          <Button
            type="button"
            size="small"
            variant="text"
            disabled
            startIcon={<AutoAwesomeIcon fontSize="small" />}
            sx={{ textTransform: "none", whiteSpace: "nowrap" }}
          >
            Show AI Note
          </Button>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      type="button"
      size="small"
      variant="text"
      onClick={toggleScribe}
      startIcon={
        isScribeCollapsed ? (
          <AutoAwesomeIcon fontSize="small" />
        ) : (
          <VisibilityOffIcon fontSize="small" />
        )
      }
      sx={{ textTransform: "none", whiteSpace: "nowrap" }}
    >
      {isScribeCollapsed ? "Show AI Note" : "Hide AI Note"}
    </Button>
  );
}
